module.exports = __webpack_public_path__ + "static/img/seckill-remind-notice.fbebb86a.png";